<template>
<span :class="bem()">
    <Button
        rect
        :class="bem('btn')"
        type="primary"
        nativeType="button"
        @click="sendCode"
        :disabled="!!codePendingRemain"
    >
        {{codePendingRemain ? `${codePendingRemain}秒后获取` : '获取验证码'}}
    </Button>
    <CapchaDialog ref="refCapchaDialog" :type="type" @onOk="capchaSendOk" />
</span>

</template>
<script>
import _Button from "@gaoding/gdui/lib/button";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import bemMixin from './bem';
import CapchaDialog from './capchaDialog/index.vue';
export default {
  name: 'g-verify-code',
  components: {
    Button: _Button,
    CapchaDialog: CapchaDialog
  },
  mixins: [bemMixin],
  props: {
    // 发送验证码方法，在按钮倒计时之前执行
    sendVerifyCode: {
      type: Function,
      required: true
    },
    // 提交图形验证码需要和发送验证码一样的type
    type: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      codePendingRemain: null
    };
  },
  inject: ['vm'],
  methods: {
    sendCode: function sendCode() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.sendVerifyCode();

              case 3:
                _this.startCheckCodePending();

                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.message === '请输入图形验证码') {
                  _this.$refs.refCapchaDialog.show();
                }

                _this.vm.$emit('error', {
                  error: _context.t0,
                  action: 'verifyCode',
                  type: 'verifyCode'
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }))();
    },
    // 发送图形验证码回调
    capchaSendOk: function capchaSendOk() {
      this.startCheckCodePending();
    },
    // 按钮倒计时
    startCheckCodePending: function startCheckCodePending() {
      var _this2 = this;

      var check = function check() {
        _this2.codePendingRemain -= 1;

        if (_this2.codePendingRemain <= 0) {
          _this2.codePendingRemain = null;
          return;
        }

        _this2.codePendingTimer = setTimeout(check, 1000);
      };

      clearTimeout(this.codePendingTimer);
      this.codePendingTimer = setTimeout(check, 1000);
      this.codePendingRemain = 60;
    }
  }
};
</script>
<style>
.g-verify-code__btn {
  flex: 0 0 auto;
  width: 86px;
  height: 40px;
  padding: 0;
  margin-left: 8px;
  font-size: 14px;
  font-weight: 600;
  border: none;
}

</style>
